import type { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import type { Sites } from '@ps/platform-message-framework/common/Sites';

export interface ActiveTableState {
  activeTablesCount: number;
}

export enum MessageType {
  OPEN_GAME = 'open_game',
  HANDSHAKE = 'handshake'
}

export enum OpenTableAction {
  FOCUS = 'focus',
  OPEN = 'open',
  ALREADY_ACTIVE = 'already_active'
}

export interface OpenWindowState {
  win: Window | null;
  action: OpenTableAction;
}

export interface ActiveTableConfig {
  brand: BrandTypes;
  site: Sites;
  origin: string;
  country: string | undefined;
  xiid: string;
  timezone: string;
  newtab: boolean;
  gametype: string;
  endpoint?: string;
  hasvideosupport?: boolean;
  flags?: number;
  scriptId?: string | number;
}
